<template>
	<div id="results" class="home section">
		<div class="container">
			<div v-if="searching">
				<h3 class="title is-4 has-text-centered" v-if="$store.getters.total && $store.getters.total >= 0">searching <b>{{$store.getters.total}}</b> profiles</h3>
				<loading></loading>
			</div>
			<div v-if="!searching">
				<b-modal :active.sync="facetModal" :width="600" :can-cancel="false">
					<header class="modal-card-head">
						<p class="modal-card-title">Refine By</p>
						<div class="modal-close-button" @click="facetModal=false"></div>
					</header>
					<div class="modal-card-body">
						<div class="columns modal-card-body" style="overflow-y: scroll;">
							<refineBy :Facets="facetResults" />
						</div>
					</div>
					<footer class="modal-card-foot">
						<button class="button" type="button" @click="facetModal=false">Close</button>
					</footer>
				</b-modal>
				<div class="breathe is-hidden-desktop">
					<b-button @click="facetModal=true" expanded>
						Refine Results
					</b-button>
				</div>

				<section style="width: 20%; overflow-y: auto; height: 20%; " class="sidebar-page is-hidden-touch">
					<refineBy :Facets="facetResults" />
				</section>


				<div class="columns is-multiline">
					<div class="column is-half" v-for="result in showResults">
						<resultCard :result="result" @click="setViewed(result)"></resultCard>
					</div>
				</div>
				<div class="has-text-centered">
					<infinite-loading @infinite="loadMore">
						<div slot="spinner"><loading></loading></div>
						<div slot="no-more">End of Results</div>
					</infinite-loading>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import refineBy from '@/components/results/refineBy.vue'
	import loading from '@/components/other/loading.vue';
	import resultCard from "@/components/results/resultCard.vue";
	export default {
		components: {
			refineBy,
			loading,
			resultCard
		},
		data() {
			return {
				searchResults: [],
				facetResults: [],
				idPath: "",
				imagePath: "",
				compensation: {},
				countryLimit: 5,
				functionLimit: 5,
				languageLimit: 5,
				regionLimit: 5,
				stateLimit: 5,
				industryLimit: 5,
				facetModal: false,
				user: [],
				api: process.env.VUE_APP_BSDB_API,
				page: 0,
				searching: false,
				query: {},
				showFlags: false,
				showing: 100
			}
		},
		async created() {
			this.$store.dispatch("setSearching", true);
			this.page = 0;
			if (this.$store.getters.query != null) {
				this.searching = true;
				const results = sessionStorage.getItem("BSDBResults");
				if (results && results.length > 0) {
					this.settleResults(JSON.parse(results));
				}
				else {
					await this.search();
				}
			} else {
				this.$buefy.toast.open({ message: "You must search first.", type: "is-warning" })
				this.$router.push("/");
			}
		},
		methods: {
			setViewed(result) {
				result.HasViewed = true;
				sessionStorage.setItem("BSDBResults", JSON.stringify({ averageComp: results.averageComp, count: results.count, facetResults: this.facetResults, searchResults: this.searchResults, queryId: results.queryId }));
			},
			settleResults(results) {
				var profiles = [];
				profiles = this.$store.getters.flagged.flagged != null ? this.$store.getters.flagged.flagged : [];

				var d = [];
				d = results.searchResults;
				if (profiles.length > 0) {
					d.forEach(r => {
						profiles.some(p => {
							if (p.UserId == r.UserId) {
								r.FlagColor = p.Color;
								r.IsFlagged = true;
							}
						})
					})
				}
				d.forEach(r => {
					this.searchResults.push(r);
				})

				if (!this.$store.getters.queryId) {
					this.$store.dispatch("setQueryId", results.queryId);
				}
				this.$store.dispatch("setSearchObject", { count: results.count, averageComp: results.averageComp });
				this.$store.dispatch("setSearching", false);
				this.facetResults = results.facetResults;
				this.searching = false;
				this.page++;
				sessionStorage.setItem("BSDBResults", JSON.stringify({ averageComp: results.averageComp, count: results.count, facetResults: this.facetResults, searchResults: this.searchResults }));
				return d;
			},
			search: async function () {
				this.query = this.$store.getters.query;

				if (this.query) {
					try {
						var resp = await this.$http.post("api/search", { query: this.query, viewCompensation: this.$store.getters.showCompensation && this.$store.getters.hideCompensation, page: this.page });

						if (resp.data == "") {
							this.$buefy.toast.open({ message: "The search has failed.", type: "is-danger" });
							this.$store.dispatch("setSearching", false);
							this.$router.push("/");
						} else {
							if (resp.data.searchResults.length < 1 && this.page == 0) {
								this.$buefy.toast.open({ message: "The search returned no results. Please modify the search.", type: "is-danger" })
								this.$router.push("/");
							} else {
								this.settleResults(resp.data);
							}
						}
						this.searching = false;
						return resp;
					}
					catch (err) {
						console.error(err);
						this.$store.dispatch("setSearching", false);
						this.searching = false;
					}
				}
			},
			async loadMore($state) {
				if (this.showing < this.searchResults.length) {
					setTimeout(() => {
						this.showing += 100;
						$state.loaded();
					}, 500);
				}
				else {
					try {
						var results = await this.search();
						$state.loaded();
						//console.log(results);
						if (results.data.searchResults.length < 1) {
							$state.complete();
						}
					} catch (err) {
						console.log(err);
						$state.complete();
						$state.error;
					}
				}
			},
		},
		computed: {
			countryLimits() {
				return this.countryLimit ? this.results.slice(0, this.countryLimit) : this.results
			},
			funtionLimits() {
				return this.functionLimit ? this.results.slice(0, this.functionLimit) : this.results
			},
			languageLimits() {
				return this.languageLimit ? this.results.slice(0, this.languageLimit) : this.results
			},
			regionLimits() {
				return this.regionLimit ? this.results.slice(0, this.regionLimit) : this.results
			},
			stateLimits() {
				return this.stateLimit ? this.results.slice(0, this.stateLimit) : this.results
			},
			industryLimits() {
				return this.industryLimit ? this.results.slice(0, this.industryLimit) : this.results
			},
			genderLimits() {
				return this.industryLimit ? this.results.slice(0, 3) : this.results
			},
			showResults() {
				return this.searchResults.slice(0, this.showing);
			}
		}
	}
</script>

<style>


	.home section {
		float: left;
		padding: 2px;
		margin-left: 2%;
		width: 50%;
		text-align: left;
	}

	.home label {
		padding: 2px;
	}

	.modal-close-button {
		@extend .modal-close;
		position: relative;
		top: 0;
		right: 0;
		background: #0000007a;
	}
</style>
